/**
 * Created with IntelliJ IDEA.
 * User: Noam and Me
 * Date: 8/2014
 * Time: non of your business why do you want to know?
 *.
 */
define(function (require) {
    'use strict';

    var LE = require("app");
    var Page = require("ui.components/page/Page");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var ScheduleEditView = require("manager-views/schedule/ScheduleEditView");
    var ScheduleModel = require("models/entities/ScheduleModel");
    var GalleryController = require("src/components/gallery-service/controllers/GalleryController");
    var NameUtility = require("utils/NameUtility");
    var Button = require("ui/button/Button");
    var CONST = require("const");

    var MODES = {
        WORKING_HOURS_SITE: "workingHoursSite",
        WORKING_HOURS_SKILL: "workingHoursSkill",
        CAMPAIGN_SCHEDULING: "campaignScheduling"
    };

    var EDIT_ITEM_ROUTE_PREFIX = "edit";

    var ScheduleController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ScheduleController = Marionette.Controller.extend({
            initialize: function(options) {
                this._initialize(options);
            },
            showScheduleGallery: function(options) {
                this._showScheduleGallery(options);
            },
            showScheduleEdit: function(options) {
                this._showScheduleEdit(options);
            },
            getView: function() {
                return this._getView();
            },


            _initialize: function(options) {
                LEManager.logger.info("initializing", "ScheduleController:initialize");
                this.mode = options.mode;
                this.galleryChannel = LEManager.media.channel(LE.mediaCodes.manager.channels.SCHEDULE_LIST + "_" + this.mode); // we concat the mode to avoid multiple listeners, something like namespace
                this.editChannel = LEManager.media.channel(LE.mediaCodes.manager.channels.SCHEDULE_EDIT + "_" + this.mode); // we concat the mode to avoid multiple listeners, something like namespace

                this._initGallery();
                this._bindEvents();
            },

            _initGallery: function () {
                this.schedulesCollection = LEManager.getModuleDataManager().getSchedulesCollection();

                this.galleryController = new GalleryController({
                    module: LEManager,
                    channel: this.galleryChannel,
                    galleryCollection: this.schedulesCollection,
                    allowDuplicate: true,
                    galleryTitle: LE.translator.translate("LEManager.scheduleGalleryView.title"),
                    galleryDescription: LE.translator.translate("LEManager.scheduleGalleryView.description"),
                    deleteConfirmTitle: LE.translator.translate("LEManager.scheduleGalleryView.delete.confirm.title"),
                    deleteConfirmMessage: LE.translator.translate("LEManager.scheduleGalleryView.delete.confirm.text"),
                    deleteErrorTitle: LE.translator.translate("LEManager.scheduleGalleryView.delete.error.title"),
                    deleteInUseErrorMessage: LE.translator.translate("LEManager.scheduleGalleryView.delete.error.text"),
                    duplicateManually: true,
                    editItemRoutePrefix: EDIT_ITEM_ROUTE_PREFIX,
                    checkDependenciesLeaves: false
                });
            },

            _bindEvents: function() {
                //routing
                this.listenTo(this.editChannel.vent, "ScheduleEditView:cancel", this._onEditCancel);
                this.listenTo(this.editChannel.vent, "ScheduleEditView:save", this._onEditSave);

                //model
                this.listenTo(this.editChannel.vent, "ScheduleEditView:change:name", this._onNameChange);
                this.listenTo(this.editChannel.vent, "ScheduleEditView:change:description", this._onDescriptionChange);
                this.listenTo(this.editChannel.vent, "ScheduleEditView:change:timezone", this._onTimezoneChange);
                this.listenTo(this.editChannel.vent, "ScheduleEventItem:change:type", this._onTypeChange);
                this.listenTo(this.editChannel.vent, "ScheduleShiftsList:change:shiftsCollection:add", this._onShiftsCollectionAdd);
                this.listenTo(this.editChannel.vent, "ScheduleShiftsList:change:shiftsCollection:remove", this._onShiftsCollectionRemove);
                this.listenTo(this.editChannel.vent, "ScheduleShiftItem:change:hours:startTime", this._onSelectedShiftStartTimeChange);
                this.listenTo(this.editChannel.vent, "ScheduleShiftItem:change:hours:endTime", this._onSelectedShiftEndTimeChange);

                //gallery
                this.listenTo(this.galleryChannel.vent, "gallery:duplicate", this._onGalleryDuplicate);
                this.listenTo(this.galleryChannel.vent, "gallery:done", this._onGalleryDone);
                this.listenTo(this.galleryChannel.vent, "gallery:cancel", this._onGalleryCancel);
            },

            _getView: function() {
                this._initPageView();
                return this.pageView;
            },

            _initPageView: function () {
                if (this.pageView) {
                    this.pageView.close();
                }
                this.pageView = new Page({
                    moduleName: LEManager.moduleName,
                    context: LE.context
                });
            },

            _showScheduleGallery: function (options) {
                options = options || {};

                var selectedItemId = options.selectedItemId || this.schedulesCollection.getDefaultId();
                var showGalleryOptions = {
                    selectedItemId: selectedItemId,
                    page: this.pageView,
                    buttonOptions: {
                        cancelBtn: {
                            initState: Button.STATES.ENABLED
                        },
                        doneBtn: {
                            initState: Button.STATES.ENABLED,
                            text: LE.translator.translate("LEFramework.global.captions.done")
                        }
                    },
                    collectionMap : {"key" : "id", "isEditable": "isEditable","isViewable":"isViewable","isUserDefault":"isUserDefault" },
                    contextEntity: {
                        id: options.contextEntityId,
                        supportedDependeeTypes: ["LECampaignObject", "ACSkillObject"]
                    },
                    showDependencyTypeTitle: true,
                    maxItemsToDisplay: 5
                };
                this.contextEntityId = options.contextEntityId;
                this.galleryController.showGallery(showGalleryOptions);
            },

            _showScheduleEdit: function (options) {
                if (!_.isEmpty(this.insideView)){
                    LEManager.closeLoader();
                    return;
                }

                if (options.scheduleId === CONST.ROUTING.NEW_ITEM_ID) {
                    this._prepareNewSchedulePage();
                } else {
                    this._prepareEditSchedulePage(options.scheduleId);
                }
            },

            _prepareNewSchedulePage: function () {
                var title = LE.translator.translate("LEManager.scheduleEditView.add.title");
                var description = LE.translator.translate("LEManager.scheduleEditView.add.description");
                this.pageView.setTitle(title);
                this.pageView.setDescription(description);
                this.scheduleModel = new ScheduleModel();
                this._showEditItemPage();
            },
            _prepareEditSchedulePage: function (scheduleId) {
                var title = LE.translator.translate("LEManager.scheduleEditView.edit.title");
                var description = LE.translator.translate("LEManager.scheduleEditView.edit.description");
                this.pageView.setTitle(title);
                this.pageView.setDescription(description);
                this.scheduleModel = new ScheduleModel({id: scheduleId});

                this.scheduleModel.fetch({
                    success: _.bind(function (model, response, options) {
                        LEManager.logger.debug("fetch success gallery Item for edit: " + model.id, "ScheduleController:showEditItem");
                        this._showEditItemPage();
                    }, this),
                    error: _.bind(function (model, response, options) {
                        LEManager.logger.debug("Could not fetch gallery Item for edit: " + model.id, "ScheduleController:showEditItem");
                        if (response && response.responseError && !_.isEmpty(response.responseError.message)) {
                            LEManager.notifier.showError({content: response.responseError.message, timeToShow: 6000});
                        }
                        LEManager.closeLoader();
                        this._onEditCancel();

                    }, this)
                });
            },

            _showEditItemPage: function () {
                this.insideView = new ScheduleEditView({
                    model: this.scheduleModel,
                    channel: this.editChannel
                });
                this.pageView.setActionStrip(false);
                this.pageView.setDependency({});
/*                this.pageView.setDependency({
                    model: this.scheduleModel,
                    success: _.bind(this._onDependenciesSuccess, this),
                    onItemClick: _.bind(this._onDependencyItemClick)
                });*/
                this.pageView.setInsideView(this.insideView);
                this.listenTo(this.insideView, "close", this._onInsideViewClose);
                LEManager.closeLoader();
            },

            _onEditCancel: function () {
                LEManager.router.navigateBack();
            },

            _onEditSave: function () {
                this._beforeSave();
                var isNewModel =  this.scheduleModel.isNew();
                this.scheduleModel.save(null, {
                    success: _.bind(this._onSaveSuccess, this, {isNewModel: isNewModel}),
                    error: _.bind(this._onSaveError, this)
                });
            },
            _onSaveSuccess: function (model, resp, options) {
                LEManager.getModuleDataManager().updateCollection(model, {silent:false});
                if (options.isNewModel){  //a new model should be selected on the gallery
                    this.galleryController.updateSelectedItemId(model.id);
                }
                this._afterSave();
                LEManager.router.navigateBack();
            },

            _onSaveError: function (model, response, options) {
                LEManager.logger.error("Failed to save content", "ScheduleController:_onEditSave", response);
                var errors = {};
                var errorMessage = LE.translator.translate("LEFramework.something.went.wrong");

                if (response && _.has(response, "responseError") ) {
                    errorMessage = response.responseError.message ? response.responseError.message : errorMessage;
                    if (response.responseError.internalCode === ErrorCodes.concurrentModificationConflictGen2Code) {
                        errorMessage = LE.translator.translate("LEFramework.entities.schedule.errors.outdated.revision");
                    } else if (response.responseError.internalCode === ErrorCodes.noDataFound) {
                        errorMessage = LE.translator.translate("LEFramework.entities.schedule.errors.schedule.was.deleted");
                        this._onEditCancel();
                    } else if (response.responseError.internalCode === ErrorCodes.uniquenessViolation) {
                        errorMessage = this._getGeneralErrorMessageNote();
                        errors[model.KEYS.NAME] = LE.translator.translate("LEFramework.entities.schedule.errors.name.duplicate");
                    }
                }
                this._afterSave();
                LEManager.notifier.showError(errorMessage);
                if(!_.isEmpty(errors)) {
                    this.editChannel.trigger("save:error", model, errors);
                }
            },

            _beforeSave: function() {
                LEManager.showLoader();
                this.listenTo(this.scheduleModel,"invalid",this._onInvalid);
            },

            _afterSave: function() {
                this.stopListening(this.scheduleModel, "invalid");
                LEManager.closeLoader();
            },

            _clearScheduleEditData: function () {
                if (this.scheduleModel) {
                    this.stopListening(this.scheduleModel);
                    this.scheduleModel = null;
                }
            },

            _onNameChange: function(name){
                this.scheduleModel.setName(name);
            },

            _onDescriptionChange: function(description){
                this.scheduleModel.setDescription(description);
            },

            _onTimezoneChange: function (timezone) {
                this.scheduleModel.setTimezone(timezone);
            },

            _onTypeChange: function (scheduleEventModel, selectedType) {
                scheduleEventModel.setType(selectedType);
            },

            _onShiftsCollectionAdd: function (scheduleEventModel) {
                scheduleEventModel.addShiftItem();
            },

            _onShiftsCollectionRemove: function (scheduleEventModel, shiftModel) {
                scheduleEventModel.removeShiftItem(shiftModel);
            },

            _onSelectedShiftStartTimeChange: function (shiftModel, selectedStartTime) {
                shiftModel.setStartTime(selectedStartTime);
            },

            _onSelectedShiftEndTimeChange: function (shiftModel, selectedEndTime) {
                shiftModel.setEndTime(selectedEndTime);
            },

            _onGalleryDuplicate: function(selectedItemId) {
                var modelToDuplicate = this.schedulesCollection.get(selectedItemId);
                if (modelToDuplicate) {
                    var newModel = modelToDuplicate.clone();
                    var newModelName = NameUtility.duplicateName(this.schedulesCollection, modelToDuplicate.getName());
                    newModel.set("id", null); // in order to create new model
                    newModel.setName(newModelName);
                    newModel.setIsDefault(false);
                    LEManager.showLoader();
                    newModel.save(null, {
                        success: _.bind(this._onDuplicateSuccess, this),
                        error: _.bind(this._onDuplicateError, this)
                    });
                }
            },
            _onDuplicateSuccess: function(model, response, options) {
                this.schedulesCollection.add(model);
                LEManager.closeLoader();
            },

            _onDuplicateError: function(model, response, options) {
                LEManager.logger.error("Failed to duplicate target gallery item", "ScheduleController:_onDuplicateError");
                LEManager.closeLoader();
                LE.notifier.showError(LE.translator.translate("LEFramework.entities.schedule.errors.duplicate"));
            },

            _onGalleryDone: function(selectedItemId) {
                var nextPageModule = "";

                if (this.mode === MODES.WORKING_HOURS_SITE) {
                    nextPageModule = LE.LEManager.appId;
                }
                else if (this.mode === MODES.WORKING_HOURS_SKILL) {
                    nextPageModule = (LE && LE.LEUserManagement) ? LE.LEUserManagement.appId : "";
                }
                else if (this.mode === MODES.CAMPAIGN_SCHEDULING) {
                    nextPageModule = (LE && LE.LECampaigns) ? LE.LECampaigns.appId : "";
                }

                if (!_.isEmpty(nextPageModule)) {
                    var eventName = LE.mediaCodes.global.commands.schedule[this.mode];
                    LE.crossModule(nextPageModule, LE.media.actions.command, eventName, {selectedItemId: selectedItemId, contextEntityId: this.contextEntityId});
                }

                LEManager.router.navigateBack();
            },

            _onGalleryCancel: function() {
                LEManager.router.navigateBack();
            },

            _onInsideViewClose: function () {
                this._clearScheduleEditData();
                this.stopListening(this.insideView);
                this.insideView = null;
            },

            _onInvalid: function(model, modelErrors){
                if (_.has(modelErrors, "events.0.end.dateTime")) { //it actually means that all events are "off"
                    LEManager.notifier.showError(LE.translator.translate(modelErrors["events.0.end.dateTime"]));
                }
                else {
                    this._showGeneralNotificationError();
                }
                LEManager.closeLoader();
            },

            _showGeneralNotificationError: function(){
                var generalError = this._getGeneralErrorMessageNote();
                LEManager.notifier.showError(generalError);
            },

            _getGeneralErrorMessageNote: function () {
                var generalError = LE.translator.translate("LEFramework.errors.generalError");
                var errorWord = LE.translator.translate("LEFramework.errors.generalError.errors.text");
                generalError = generalError.replace("{0}", errorWord).replace("{1}", "");
                return generalError;
            },

            //TODO: TOMER: figure out what the ...... is doing here and not only in GalleryController
            _onDependenciesSuccess: function(dependencyCollection) {
                var config = {};

                var campaignDependencies = dependencyCollection.where({type: "LECampaignObject"});
                if (campaignDependencies.length > 0) {
                    config.title = LE.translator.translate("LECampaigns.goalDetailsView.dependencyIndicator.tooltipTitle.campaigns");

                    config.dependencyArr = _.map(campaignDependencies, function(dependencyModel) {
                        return LEManager.getModuleDataManager().getDependencyData(dependencyModel);
                    });

                }
                else {
                    config.title = LE.translator.translate("LECampaigns.segments.edit.dependencyIndicator.tooltipTitle.other");
                }

                return config;
            },
            _onDependencyItemClick: function(model) {
                LEManager.router.navigate(model.get("url"));
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    ScheduleController.MODES = MODES;

    return  ScheduleController;
});
